module.exports = __webpack_public_path__ + "img/copy.53312e49.svg";